import styled, { keyframes } from "styled-components";
import React, { useEffect, useState } from "react";
import { CircularProgress } from '@material-ui/core'
import { useKeycloak } from "react-keycloak";
import { GetProcessLogsQuery, ProcessLogDto, useGetProcessLogsLazyQuery } from "../../api/models";
import { createBaseContext } from "../../services/apiService";
import { get as _get } from "lodash";

const AppProgressIndicatorWrapper = styled.div`
    height: 30px;
    bottom: 30px;
    right: 20px;
    z-index: 1000;
    position: absolute;
    display: flex;
    color: #467abd;
`

interface AppProgressIndicatorProps {
    timeoutInterval?: number
}

export const AppProgressIndicator: React.FC<AppProgressIndicatorProps> = (props: AppProgressIndicatorProps) => {
    const { timeoutInterval } = props
    const [processRunning, setProcessRunning] = useState(false)
    const [keycloak] = useKeycloak()

    const [processLogsQuery, processLogsResponse] = useGetProcessLogsLazyQuery(
        createBaseContext(keycloak.token || '', {
            filter: [{ field: 'status', expected: 'IN_PROGRESS' }]
        })
    )

    useEffect(() => {
        if (!processLogsResponse.called) {
            processLogsQuery()
        }
    }, [processLogsResponse, processLogsQuery])

    useEffect(() => {
        const interval = setInterval(() => {
            processLogsQuery()
        }, timeoutInterval || 2000)
        return () => clearInterval(interval)
    }, [processLogsQuery])

    useEffect(() => {
        if (processLogsResponse.data && !processLogsResponse.loading) {
            const extractedData = _get(processLogsResponse, "data.getProcessLogs.data", [])
            setProcessRunning(extractedData.length > 0)
        }
    }, [processLogsResponse.data])

    if (processRunning) {
        return (
            <AppProgressIndicatorWrapper>
                <CircularProgress color={"secondary"}   />
            </AppProgressIndicatorWrapper>
        )
    }
    return null
}
